<div class="container-fluid mb-5">
    <div class="container-xxl" id="about">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="about-img">
                        <img class="img-fluid w-100" src="assets/img/About.jpg">
                    </div>
                </div>
                <div class="col-lg-6">
                    <h1 class="display-5 mb-4 font-weight-bolder">Partner with MyKadai – Grow Your Business Online</h1>
                    <h6 class="mb-3 d-md-block d-none">Join MyKadai and take your business to the next level.</h6>
                    <span class="mb-3 d-md-block d-none">Whether you run a grocery store, restaurant, pharmacy, bakery,
                        or
                        even a taxi
                        service, MyKadai is the perfect platform to connect with thousands of local customers looking
                        for services just like yours.</span>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid bg-light bg-icon my-5 py-6">
        <div class="container">
            <div class="section-header text-center mx-auto mb-5 " data-aos="fade-right">
                <h1 class="display-5 mb-3 font-weight-bolder">Why Sell on MyKadai?</h1>
            </div>
            <div class="row g-4" data-aos="fade-left">
                <div class="col-lg-4 col-md-6">
                    <div class="bg-white text-center h-100 p-4 p-xl-5">
                        <img class="img-fluid mb-4 icon-size" src="assets/img/shop/outreach.png" alt="">
                        <h4 class="mb-3">Reach More Customers</h4>
                        <p class="mb-4">Get discovered by new and nearby customers who are searching for products and
                            services online. With MyKadai, your business is visible to a growing user base that trusts
                            the platform for everyday needs.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 ">
                    <div class="bg-white text-center h-100 p-4 p-xl-5">
                        <img class="img-fluid mb-4 icon-size" src="assets/img/shop/boost.png" alt="">
                        <h4 class="mb-3">Boost Your Sales</h4>
                        <p class="mb-4">List your products or services and watch your business grow. From daily
                            essentials to niche offerings, MyKadai helps you sell more without worrying about storefront
                            limitations.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 ">
                    <div class="bg-white text-center h-100 p-4 p-xl-5">
                        <img class="img-fluid mb-4 icon-size" src="assets/img/shop/customer-support.png" alt="">
                        <h4 class="mb-3">Simple Onboarding</h4>
                        <p class="mb-4">Our easy registration and product listing process help you get started quickly.
                            No tech expertise required – our team is here to assist every step of the way.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="bg-white text-center h-100 p-4 p-xl-5">
                        <img class="img-fluid mb-4 icon-size" src="assets/img/icons/secure-payment.png" alt="">
                        <h4 class="mb-3">Secure Payments</h4>
                        <p class="mb-4">Enjoy seamless and secure online payments. Focus on fulfilling orders while we
                            handle the transactions with transparency and reliability</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 ">
                    <div class="bg-white text-center h-100 p-4 p-xl-5">
                        <img class="img-fluid mb-4 icon-size" src="assets/img/icons/flash-sale.png" alt="">
                        <h4 class="mb-3">Efficient Order Management</h4>
                        <p class="mb-4">Track and manage orders in real-time. Whether it’s a food order, medicine
                            request, or grocery delivery, we make sure everything runs smoothly.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 ">
                    <div class="bg-white text-center h-100 p-4 p-xl-5">
                        <img class="img-fluid mb-4 icon-size" src="assets/img/shop/social-media.png" alt="">
                        <h4 class="mb-3">Marketing and Promotions</h4>
                        <p class="mb-4">Leverage our platform promotions, offers, and seasonal campaigns to increase
                            visibility and attract more buyers.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid my-5 py-6">
        <div class="container">
            <div class="section-header text-center mx-auto mb-5 ">
                <h1 class="display-7 mb-3 font-weight-bolder">Who Can Join MyKadai?</h1>
            </div>
            <div class="row gy-4">
                <div class="col-lg-4 col-md-6">
                    <h4 class="text-bold mb-2 text-center">Grocery & Fresh Produce</h4>
                    <div class="single-img">
                        <img src="assets/img/icons/grocery.png" alt="Avatar" class="image p-5">
                        <div class="img-overlay">
                            <div class="text">
                                <p class="text-bold">Farm-fresh fruits and vegetables, pantry staples,
                                    organic products, and everyday essentials—all delivered
                                    fresh and fast.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <h4 class="text-bold mb-2 text-center">Restaurants</h4>
                    <div class="single-img">
                        <img src="assets/img/icons/restaurant.png" alt="Avatar" class="image p-5">
                        <div class="img-overlay">
                            <div class="text">
                                <p class="text-bold">Order from your favorite local eateries, cafés, and dessert spots.
                                    Whether it’s a full meal or a midnight snack, we deliver it hot and tasty.</p>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="col-lg-4 col-md-6">
                    <h4 class="text-bold mb-2 text-center">Pharmacy & Ayurveda</h4>
                    <div class="single-img">
                        <img src="assets/img/icons/pharmacy.png" alt="Avatar" class="image p-5">
                        <div class="img-overlay">
                            <div class="text">
                                <p class="text-bold">Access a wide range of health products, prescription medicines, and
                                    natural wellness items with doorstep delivery and safety compliance.</p>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="col-lg-4 col-md-6">
                    <h4 class="text-bold mb-2 text-center"> Fresh Meat & Seafood</h4>
                    <div class="single-img">
                        <img src="assets/img/icons/meat.png" alt="Avatar" class="image p-5">
                        <div class="img-overlay">
                            <div class="text">
                                <p class="text-bold">Hygienically packed, freshly sourced meat and seafood options from
                                    trusted local vendors.</p>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="col-lg-4 col-md-6">
                    <h4 class="text-bold mb-2 text-center">Stationery</h4>
                    <div class="single-img">
                        <img src="assets/img/icons/office-supplies.png" alt="Avatar" class="image p-5">
                        <div class="img-overlay">
                            <div class="text">
                                <p class="text-bold">School and office supplies—all
                                    available in a few clicks.</p>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="col-lg-4 col-md-6">
                    <h4 class="text-bold mb-2 text-center">Bakery</h4>
                    <div class="single-img">
                        <img src="assets/img/icons/bakery.png" alt="Avatar" class="image p-5">
                        <div class="img-overlay">
                            <div class="text">
                                <p class="text-bold">Breads, cakes, party essentials,
                                    available in a few clicks.</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>


    <div class="container-fluid bg-light bg-icon my-5 py-6">
        <div class="container">
            <div class="section-header text-center mx-auto mb-5" data-aos="fade-right" data-aos-delay="200">
                <h1 class="display-5 mb-3 font-weight-bolder">Your Success Is Our Goal</h1>
            </div>
            <div class="row g-4">
                <div class="col-12">
                    <h6 class="font-weight-bolder">At MyKadai, we’re committed to supporting local businesses. We offer
                        tools, insights, and dedicated support to help you scale, manage, and succeed in a competitive
                        digital space.</h6>
                </div>
            </div>
        </div>
    </div>


    <div class="container-fluid my-5 py-6" id="pricing">
        <div class="container-fluid col-11 mx-auto">
            <div class="section-header text-center mx-auto mb-5" data-aos="fade-right">
                <h1 class="display-5 mb-3 fw-bold">Pricing Plans</h1>
            </div>

            <!-- Loading Spinner -->
            <div *ngIf="loading" class="text-center py-5">
                <div class="spinner-border text-success" role="status"></div>
            </div>


            <!-- Pricing Cards Main Screen -->
            <div class="row g-4 justify-content-center" *ngIf="pricingPlans.length > 0">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex"
                    *ngFor="let plan of pricingPlans; let i = index" data-aos="fade-up">
                    <div class="card shadow-sm border-0 rounded-4 flex-fill position-relative hover-card"
                        [ngStyle]="{'background-color': cardColors[i % cardColors.length]}">

                        <!-- Unique Badge -->
                        <div *ngIf="plan.tag" class="badge-custom position-absolute top-0 end-0 mt-3 me-3">
                            {{ plan.tag }}
                        </div>

                        <!-- Card Header -->
                        <div class="card-header text-white border-0 rounded-top-4 text-center py-4"
                            [ngStyle]="{'background-color': headerColors[i % headerColors.length]}">
                            <h5 class="fw-bold mb-1 text-capitalize">{{ plan.packageName || 'Unnamed Plan' }}</h5>
                            <p *ngIf="plan.description" class="mb-0 fs-6" style="opacity: 0.85;">
                                {{ plan.description }}
                            </p>
                        </div>

                        <!-- Card Body -->
                        <div class="card-body d-flex flex-column text-center p-4">

                            <!-- Monthly / Yearly Price -->
                            <h2 class="fw-bold text-dark mb-4" *ngIf="plan.isMonthly || plan.isYearly">
                                <span *ngIf="plan.isMonthly">
                                    ₹{{ plan.priceMonthly || 0 }} <span class="fs-6 text-muted">/month</span>
                                </span>
                                <span *ngIf="plan.isMonthly && plan.isYearly"> &nbsp; | &nbsp; </span>
                                <span *ngIf="plan.isYearly">
                                    ₹{{ plan.priceYearly || 0 }} <span class="fs-6 text-muted">/year</span>
                                </span>
                            </h2>

                            <!-- Features List -->
                            <ul class="list-unstyled text-start mb-4 flex-grow-1">
                                <li *ngFor="let feature of plan.featureDetails" class="mb-2 d-flex align-items-center">
                                    <i class="fas fa-check-circle me-2 text-success"
                                        *ngIf="feature.value === 'yes'"></i>
                                    <i class="fas fa-times-circle me-2 text-danger" *ngIf="feature.value === 'no'"></i>
                                    <i class="fas fa-check-circle me-2 text-success"
                                        *ngIf="feature.value && feature.value !== 'yes' && feature.value !== 'no'"></i>
                                    <span>{{ feature.featureName }}
                                        <span class="text-bold"
                                            *ngIf="feature.value && feature.value !== 'yes' && feature.value !== 'no'">
                                            {{ feature.value }}
                                        </span>
                                    </span>
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
            </div>

            <!-- Empty State -->
            <div *ngIf="!pricingPlans.length" class="text-center text-muted py-5">
                No active pricing plans available yet.
            </div>


            <div class="container-fluid bg-light bg-icon my-5 py-6">
                <div class="container">
                    <div class="section-header text-center mx-auto mb-5" data-aos="fade-right" data-aos-delay="200">
                        <h1 class="display-5 mb-3 font-weight-bolder">Ready to Start Selling?</h1>
                    </div>
                    <div class="row g-4">
                        <div class="col-12 text-center">
                            <h4 class="font-weight-bold">Become a MyKadai Partner Today</h4>
                            <h6 class="font-weight-normala">Join our growing network of local businesses and start
                                reaching
                                thousands of customers in your area.</h6>
                        </div>

                        <div class="col-lg-4 col-md-4 col-12 text-center"></div>
                        <div class="col-lg-4 col-md-4 col-12 text-center">
                            <a class="btn btn-success btn-block p-2" [routerLink]="['/shop-owner-register']">Join
                                Now</a>
                        </div>
                        <div class="col-lg-4 col-md-4 col-12 text-center"></div>
                    </div>
                </div>
            </div>

            <div class="container-fluid my-5 py-6">
                <div class="container">
                    <div class="section-header text-center mx-auto mb-5" data-aos="fade-right" data-aos-delay="200">
                        <h1 class="display-5 mb-3 font-weight-bolder">How It Works?</h1>
                    </div>
                    <div class="steps-container">
                        <div class="step">
                            <div class="icon"><i class="bi bi-shop"></i></div>
                            <h3>Register Your Shop</h3>
                            <p>No documents or fees needed.</p>
                        </div>
                        <div class="step">
                            <div class="icon"><i class="bi bi-upload"></i></div>
                            <h3>Upload Products</h3>
                            <p>Easily via your phone.</p>
                        </div>
                        <div class="step">
                            <div class="icon"><i class="bi bi-broadcast"></i></div>
                            <h3>Go Live</h3>
                            <p>Customers can view and order instantly.</p>
                        </div>
                        <div class="step">
                            <div class="icon"><i class="bi bi-list-check"></i></div>
                            <h3>Manage Orders</h3>
                            <p>With a simple dashboard.</p>
                        </div>
                        <div class="step">
                            <div class="icon"><i class="bi bi-graph-up"></i></div>
                            <h3>Track Growth</h3>
                            <p>Full control, zero hassle.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>